import {Button} from "@material-tailwind/react";
import React from "react";
import {getPersonsNameAndFamily, getPersonsPhone} from "../../services/profile/profile";
import Dict from "../../helper/dict";
import FromToDateField from "../system/fromToDateField";
import FromToNumberField from "../system/fromToNumberField";
import SelectInput from "../system/select";

const WITHDRAWAL_STATUS_OPTIONS = [
  {id: "", title: "همه"},
  {id: "new", title: "در انتظار بررسی"},
  {id: "accepted", title: "انجام شده"},
  {id: "rejected", title: "رد شده"},
];

export function AdminWithdrawalFilter({
                                        personId,
                                        setPersonId,
                                        status,
                                        setStatus,
                                        minValue,
                                        setMinValue,
                                        maxValue,
                                        setMaxValue,
                                        dateFrom,
                                        setDateFrom,
                                        dateTo,
                                        setDateTo,
                                        hasRows,
                                        onClear,
                                        onExport,
                                        onOpenSources,
                                        sourcesDisabled,
                                      }) {
  return (
    <>
      <div className="mb-8 grid grid-cols-1 gap-4 md:grid-cols-3 xxl:grid-cols-3">
        <div className="flex flex-col">
          <SelectInput
            label="نام"
            defaultValue={personId}
            refreshSignal={personId}
            autoLoadService={getPersonsNameAndFamily}
            autoLoadRender={({name, family, phone}) => {
              const fullName = `${name?.trim()} ${family?.trim()}`.trim();
              return `${fullName} - ${phone}`;
            }}
            onChange={setPersonId}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            label={Dict("phone")}
            defaultValue={personId}
            refreshSignal={personId}
            autoLoadService={getPersonsPhone}
            autoLoadRender={({phone}) => phone}
            onChange={setPersonId}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            label="وضعیت"
            defaultValue={status}
            refreshSignal={status}
            options={WITHDRAWAL_STATUS_OPTIONS}
            onChange={setStatus}
          />
        </div>
      </div>

      <div className="mb-4 grid grid-cols-1 gap-1 md:grid-cols-2 xxl:grid-cols-2">
        <FromToNumberField
          label="مبلغ"
          fromNumber={minValue}
          setFromNumber={setMinValue}
          toNumber={maxValue}
          setToNumber={setMaxValue}
        />

        <FromToDateField
          className="w-full"
          label="تاریخ"
          fromDate={dateFrom}
          setFromDate={setDateFrom}
          toDate={dateTo}
          setToDate={setDateTo}
        />
      </div>

      <div className="flex flex-row justify-between">
        <Button
          variant="gradient"
          color="gray"
          onClick={onClear}
          className="ml-1"
        >
          <span>حذف فیلتر</span>
        </Button>

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outlined"
            onClick={onOpenSources}
            disabled={sourcesDisabled}
          >
            منابع
          </Button>

          {hasRows && (
            <Button size="sm" variant="outlined" onClick={onExport}>
              خروجی اکسل
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
